export default {
  default: {
    titleText: {
      create: 'Create',
      import: 'Import',
    },
    titleSecondLine: 'Project',
  },
}
